import React, { useRef, useState } from "react";
import { uploadProductExcel } from "../../../services/apiService";

const ExcelUpload = ({ reloadData }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setSelectedFile(file);
    setMessage("");
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setError("Please select a file");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      setUploading(true);
      setError("");
      setMessage("");
      const res = await uploadProductExcel(formData);
      setMessage(res?.data?.message || "File uploaded successfully");
      setSelectedFile(null);
      if (inputRef.current) inputRef.current.value = "";
      reloadData && reloadData();
    } catch (err) {
      console.error(err);
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Upload failed. Please try again."
      );
    } finally {
      setUploading(false);
    }
  };

  const inputStyle = {
    padding: "6px 10px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    background: "#fff",
    fontSize: "14px",
    cursor: "pointer",
  };

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        background: "#fff",
        borderRadius: "8px",
      }}
    >
      <h4 style={{ marginBottom: "15px" }}>Upload Excel Sheet</h4>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "12px",  color: "#125af5", }}>
          <label
            htmlFor="excelFile"
            style={{ fontWeight: 600, marginRight: "10px" }}
          >
            Choose File
          </label>
          <input
            id="excelFile"
            ref={inputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            style={inputStyle}
          />
        </div>

        {selectedFile && (
          <div style={{ marginBottom: "12px", color: "#111827" }}>
            Selected: {selectedFile.name}
          </div>
        )}

        <button
          type="submit"
          disabled={!selectedFile || uploading}
          style={{
            backgroundColor: uploading ? "#9ca3af" : "#16a34a",
            color: "#fff",
            border: "none",
            padding: "8px 18px",
            borderRadius: "6px",
            cursor: uploading ? "not-allowed" : "pointer",
            fontWeight: 600,
          }}
        >
          {uploading ? "Uploading..." : "Submit"}
        </button>
      </form>

      {message && (
        <p style={{ color: "#16a34a", marginTop: "12px" }}>{message}</p>
      )}
      {error && <p style={{ color: "#dc2626", marginTop: "12px" }}>{error}</p>}
    </div>
  );
};

export default ExcelUpload;
